import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getProjectsDataRequested() {
    return {
        type: 'GET_PROJECTS_DATA_REQUESTED'
    };
}

export function getProjectsDataDone(data) {
    return {
        type: 'GET_PROJECTS_DATA_DONE',
        payload: data
    };
}

export function getProjectsDataFailed(error) {
    return {
        type: 'GET_PROJECTS_DATA_FAILED',
        payload: error
    };
}

export function getAllProjectsDataRequested() {
    return {
        type: 'GET_ALL_PROJECTS_DATA_REQUESTED'
    };
}

export function getAllProjectsDataDone(data) {
    return {
        type: 'GET_ALL_PROJECTS_DATA_DONE',
        payload: data
    };
}

export function getAllProjectsDataFailed(error) {
    return {
        type: 'GET_ALL_PROJECTS_DATA_FAILED',
        payload: error
    };
}

export function getProjectsData(searchText) {
    let url = PropertyBucket.getAllProjects(searchText);
    return dispatch => {
        dispatch(getAllProjectsDataRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getAllProjectsDataDone(data.projects));
        })
        .catch(error => {
            dispatch(getAllProjectsDataFailed(error));
        })
    }
}

export function getPagedProjects(pageNumber, pageSize, sortBy, sortOrder, projectNumber, beneficiaryName, beneficiaryIdentityNumber, title, globalFilter) {
    let url = PropertyBucket.getProjects(pageNumber, pageSize, sortBy, sortOrder, projectNumber, beneficiaryName, beneficiaryIdentityNumber, title, globalFilter);
    return dispatch => {
        dispatch(getProjectsDataRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getProjectsDataDone(data));
        })
            .catch(error => {
                dispatch(getProjectsDataFailed(error));
            })
    }
}

export const GET_PROJECTS_DATA_REQUESTED = 'GET_PROJECTS_DATA_REQUESTED';
export const GET_PROJECTS_DATA_DONE = 'GET_PROJECTS_DATA_DONE';
export const GET_PROJECTS_DATA_FAILED = 'GET_PROJECTS_DATA_FAILED';
export const GET_ALL_PROJECTS_DATA_REQUESTED = 'GET_ALL_PROJECTS_DATA_REQUESTED';
export const GET_ALL_PROJECTS_DATA_DONE = 'GET_ALL_PROJECTS_DATA_DONE';
export const GET_ALL_PROJECTS_DATA_FAILED = 'GET_ALL_PROJECTS_DATA_FAILED';